import { useState } from 'react';

import PhotoCardCheckBox from '../../components/card/PhotoCardCheckBox';
import type { TradingPhotoCardType } from '../types/TradingPhotoCardType';
import PriceChangePopUp from './PriceChangePopUp';
import { t } from 'i18next';
import { useSelectedTradingCardsStore } from '../store/useSelectedTradingCardsStore';

interface TradingPhotoCardProps {
  photoCard: TradingPhotoCardType;
}

const TradingPhotoCard = ({ photoCard }: TradingPhotoCardProps) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const { addPhotoCard, removePhotoCard } = useSelectedTradingCardsStore();

  const { price, category, tradingPhotoCardId, status } = photoCard;
  const { pictureUrl, memberName, categoryName, eventName, categoryEmoji } = photoCard.photoCard;

  const handleEditClick = () => {
    setIsEditDialogOpen(true);
  };

  const onPhotoCardSelect = (photoCard: TradingPhotoCardType, isSelected: boolean) => {
    if (isSelected) {
      addPhotoCard(photoCard);
    } else {
      removePhotoCard(photoCard.tradingPhotoCardId);
    }
  };

  const isSelected = useSelectedTradingCardsStore((state) =>
    state.selectedPhotoCards.some((c) => c.tradingPhotoCardId === tradingPhotoCardId)
  );

  if (category === 'sale') {
    return (
      <>
        <PhotoCardCheckBox
          imageUrl={pictureUrl}
          artistName={memberName}
          categoryName={categoryName}
          eventName={eventName}
          categoryEmoji={categoryEmoji}
          price={price ?? t('NewTradingPhotoCards.pricePlaceholder')}
          isChecked={isSelected}
          onChange={(isSelected) => onPhotoCardSelect(photoCard, isSelected)}
          icon={<EditButton onClick={handleEditClick} />}
        />

        {isEditDialogOpen && (
          <PriceChangePopUp
            price={price ?? ''}
            tradingPhotoCardId={tradingPhotoCardId}
            category={category}
            status={status}
            onClose={() => setIsEditDialogOpen(false)}
          />
        )}
      </>
    );
  }

  return (
    <PhotoCardCheckBox
      imageUrl={pictureUrl}
      artistName={memberName}
      categoryName={categoryName}
      eventName={eventName}
      categoryEmoji={categoryEmoji}
      isChecked={isSelected}
      onChange={(isSelected) => onPhotoCardSelect(photoCard, isSelected)}
    />
  );
};

export default TradingPhotoCard;

interface EditButtonProps {
  onClick: () => void;
}

const EditButton = ({ onClick }: EditButtonProps) => {
  return (
    <button
      type="button"
      className="text-[12px] leading-none text-text-primary py-[1px] mt-[1px]"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {t('NewTradingPhotoCards.edit')}
    </button>
  );
};